module.exports = __webpack_public_path__ + "images/icon/icon_24x24_stroke_close_hover-1b0c99f9.svg";